<template>
  <div class="item-container">
    <div class="custom-card-title">{{ lessons[0].lesson_name }}</div>
    <div class="custom-card-button-container">
      <div class="button" :id="`lesson-card-intermediate-${lessons[0].lesson_id}`">
        <b-button
          :variant="lessons[0].locked ? 'outline-secondary' : 'success'"
          @click="intermediateButtonClickedHandler"
          :disabled="lessons[0].locked"
        >{{$t('Typing.intermediate')}}</b-button>
      </div>
      <b-tooltip
        v-if="lessons[0].locked"
        :target="`lesson-card-intermediate-${lessons[0].lesson_id}`"
        placement="bottom"
        noninteractive
      >{{ $t('Typing.notUnlockedYet') }}</b-tooltip>

      <div class="button" :id="`lesson-card-advanced-${lessons[1].lesson_id}`">
        <b-button
          :variant="lessons[1].locked ? 'outline-secondary' : 'success'"
          v-on:click="advancedButtonClickedHandler"
          :disabled="lessons[1].locked"
        >{{$t('Typing.advanced')}}</b-button>
      </div>
      <b-tooltip
        v-if="lessons[1].locked"
        :target="`lesson-card-advanced-${lessons[1].lesson_id}`"
        placement="bottom"
        noninteractive
      >{{ $t('Typing.notUnlockedYet') }}</b-tooltip>
    </div>
  </div>
</template>

<script lang='js'>
import Vue from 'vue'

const TypingCombineLessonCard = Vue.extend({
  name: 'TypingCombineLessonCard',
  components: {
  },
  props: {
    lessons: {
      type: Array,
      required: true
    }
  },
  methods: {
    intermediateButtonClickedHandler () {
      let typingCombineIntermediateLesson = this.lessons[0]
      this.$router.push({
        name: 'typingCombineIntermediate',
        params: {
          lessonId: typingCombineIntermediateLesson.lesson_id,
          currentLesson: typingCombineIntermediateLesson
        }
      })
    },
    advancedButtonClickedHandler () {
      let typingCombineAdvancedLesson = this.lessons[1]
      this.$router.push({
        name: 'typingCombineAdvanced',
        params: {
          lessonId: typingCombineAdvancedLesson.lesson_id,
          currentLesson: typingCombineAdvancedLesson
        }
      })
    }
  }
})

export default TypingCombineLessonCard
</script>

<style lang='scss' scoped>
@import "../styles/lessonCardStyles.scss";
</style>
